// Main Table Component
export default {
  // Table Column Names
  month: "Month",
  date: "Date",
  inflowAmount: "Inflow Amount (10k)",
  outflowAmount: "Outflow Amount (10k)",

  // Summary Row
  total: "Total",

  // Transfer Statistics
  totalInflowAmount: "Total Inflow Amount",
  totalOutflowAmount: "Total Outflow Amount",
  tenThousand: "10k",
};
